import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';

import {
    ExclusiveDealsBenefit,
    ImpactBenefit,
    SavingsGuaranteePerk,
    ShippingBenefit,
} from 'features/paid-membership/Benefits';

import OddsEndsBenefit from '../Benefits/OddsEndsBenefit';

/**
 * BenefitsList component that displays a list of membership benefits
 * @param {string} [bgColor=''] - Background color class for the benefits
 * @param {'horizontal' | 'responsive'} [layout='responsive'] - Layout orientation for the benefits list
 * @param {'standard' | 'renewal' | 'memberDeals'} [savingsGuaranteeVariant='standard']
 * @param {boolean} [showSavingsGuarantee=true] - Whether to show the Savings Guarantee perk
 * @returns {JSX.Element}
 */
function BenefitsList({
    bgColor = '',
    layout = 'responsive',
    savingsGuaranteeVariant = 'standard',
    showSavingsGuarantee = true,
}) {
    const withinHorizontalBreakpoint = useMediaQuery({ maxWidth: 539 });

    const listOrientation = layout === 'horizontal' || withinHorizontalBreakpoint ? 'horizontal' : 'responsive';
    const shouldShowSavingsGuarantee = showSavingsGuarantee || savingsGuaranteeVariant === 'renewal';

    return (
        <ul className={clsx('gap-20', listOrientation === 'horizontal' ? 'flex flex-col' : 'grid grid-cols-4')}>
            {shouldShowSavingsGuarantee && (
                <li className={clsx(listOrientation === 'horizontal' ? undefined : 'col-span-4 mx-auto max-w-[565px]')}>
                    <SavingsGuaranteePerk variant={savingsGuaranteeVariant} />
                </li>
            )}
            <li>
                <ExclusiveDealsBenefit layout={listOrientation} bgColor={bgColor} />
            </li>
            <li>
                <OddsEndsBenefit layout={listOrientation} bgColor={bgColor} />
            </li>
            <li>
                <ShippingBenefit layout={listOrientation} bgColor={bgColor} />
            </li>
            <li>
                <ImpactBenefit layout={listOrientation} bgColor={bgColor} />
            </li>
        </ul>
    );
}

export { BenefitsList };
